/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import styles from './TenantDetailsComponent.module.scss';
import metadata from './TenantDetailsComponent.metadata.json5';
import OccSearchComponent from '../OccupationSearch/OccSearchComponent';

function TenantDetailsComponent(props) {

    const {
        data: TenantDetailsVM,
        updateWizardData,
        submissionVM,
        TenantDetailsPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addTenantDetails = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            TenantDetailsVM.value = TenantDetailsVM.value || []

            const { _xCenter, _dtoName } = TenantDetailsVM;

            const TenantDetailsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            TenantDetailsObjVM.isValidationReq.value = true;
            TenantDetailsObjVM.numFie.value = TenantDetailsVM?.value?.length + 1;

            TenantDetailsVM.pushElement(
                TenantDetailsObjVM
            );
            updateWizardData(submissionVM);
        },
        [TenantDetailsVM, viewModelService, updateWizardData, submissionVM]
    );


	// eslint-disable-next-line react-hooks/exhaustive-deps
    const setSubmission = useCallback((submissionVM) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);

        updateWizardData(newSubmissionVM);
    });


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            TenantDetailsVM.value.splice(index, 1);

            TenantDetailsVM.value.map((tenant) => {
                if (tenant.numFie > index) {
                    tenant.numFie = tenant.numFie - 1;
                }
            })

            _.set(submissionVM.value, TenantDetailsPath, TenantDetailsVM.value);
            updateWizardData(submissionVM);
        }, [TenantDetailsVM.value, submissionVM, TenantDetailsPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                const value = item.numFie ? item.numFie : index + 1;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'namFie1') {
                const value = item.namFie1 ? item.namFie1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namFie1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'occFie') {
                const value = item.occFie ? item.occFie : '';
                const pathUpdated = `${TenantDetailsPath}.children[${index}]`;

                return (
                    <OccSearchComponent
                        id={index + path}
                        updateWizardData={updateWizardData}
                        index={index}
                        viewModelService={viewModelService}
                        submissionVM={submissionVM}
                        pathUpdated={pathUpdated}
                        setSubmission={setSubmission}
                    />
                );
            }

            if (path === 'ageFie') {
                const value = item.ageFie ? item.ageFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.ageFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TenantDetailsTable`]: {
            data: TenantDetailsVM?.value?.sort((a,b) => a.numFie - b.numFie)
        }

    }), [TenantDetailsVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addTenantDetails,
            getTableCell,
            removeAssignmentTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            TenantDetailsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [TenantDetailsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={TenantDetailsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TenantDetailsComponent.propTypes = wizardProps;
export default withRouter(TenantDetailsComponent);
